class ProductColoursSwatches extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els?.title?.element) {
      this.originalTitle = this.els.title.element.textContent
    }
  }

  setupListeners () {
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseOut = this.onMouseOut.bind(this)

    this.listeners.add(this, 'mouseover', this.onMouseOver)
    this.listeners.add(this, 'mouseout', this.onMouseOut)

    this.els.colours.elements.forEach(colour => {
      this.listeners.add(colour, 'mouseover', this.onMouseOver)
    })
  }

  onMouseOver (event) {
    // required to get the closest element with the colour selector to avoid null value
    const titleElement = event.target.closest(this.els.colour.selector)

    if (titleElement && titleElement.dataset.title) {
      this.els.title.element.textContent = titleElement.dataset.title
    }
  }

  onMouseOut (event) {
    const currentTitle =
      this.els.title.element.dataset.currentTitle || this.originalTitle
    if (currentTitle) {
      this.els.title.element.textContent = currentTitle
    }
  }
}

if (!customElements.get('product-colours-swatches')) {
  customElements.define('product-colours-swatches', ProductColoursSwatches)
}
